import { useRef } from "react";
import { ChevronDown } from "react-feather";
import { useReactToPrint } from "react-to-print";
import { Button } from "reactstrap";
import { Send } from "../../../../../constants";
import { dynamicImage } from "../../../../../utils";
import InboxOption from "./InboxOption";
import UserFooter from "./UserFooter";
import { InboxSecurityList } from "../../../../../data/applications/LetterBox";
import UserBody from "./UserBody";
import { Image } from "../../../../../coreComponents/Image";

const MailBody = () => {

  const contentRef = useRef<HTMLDivElement | null>(null);
  const handlePrintData = useReactToPrint({ contentRef });

  return (
    <div ref={contentRef}>
      <div className="mail-body-wrapper">
        <div className="user-mail-wrapper">
          <div className="user-title">
            <div>
              <div className="rounded-border">
                <Image className="img-fluid" src={dynamicImage(`user/12.png`)} alt="user" />
              </div>
              <div className="dropdown-subtitle">
                <p className="mb-0">Ronald Richards</p>
                <div className="onhover-dropdown">
                  <Button color="transparent" className="p-0 dropdown-button">To me <ChevronDown /></Button>
                  <div className="inbox-security onhover-show-div">
                    {InboxSecurityList.map((item, index) => (
                      <p key={index}>
                        {item.label}:
                        <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <InboxOption handlePrintData={handlePrintData} />
          </div>
          <UserBody />
          <UserFooter />
          <div className="send-btn">
            <Button color="primary">
              {Send}<i className="fa fa-paper-plane" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MailBody;